import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SearchPage from './components/SearchPage';
import UpcomingMatches from './components/UpcomingMatches';
import ResultPage from './components/ResultPage';
import LoginPage from './components/LoginPage';
import RegistrationPage from './components/RegistrationPage';
import { AuthProvider } from './hooks/AuthContext';
import AboutPage from './components/AboutPage';
import ProfilePage from './components/ProfilePage';
import ProtectedRoute from './components/ProtectedRoute';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import PredefinedLeagues from './components/PredefinedLeagues';
import SavedSummaryPage from './components/SavedSummaryPage';

function App() {

  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<SearchPage />}></Route>
            <Route path='/about' element={<AboutPage />}></Route>
            <Route path="/upcomingMatches/:teamId" element={<UpcomingMatches />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path='/login' element={<LoginPage />}></Route>
            <Route path='/registration' element={<RegistrationPage />}></Route>
            <Route path='/leagues/:leagueId' element={<PredefinedLeagues />}></Route>
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route path="/match/:matchId"
              element={
                <ProtectedRoute>
                  <SavedSummaryPage />
                </ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
